import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';

import { CurrentUserEntityActions } from '@core/account-data';
import { AsyncJobActions } from '@core/async-job-data';
import { AsyncJobType } from '@core/async-job-types';

import { JobRequisitionsActions } from './job-requisitions/job-requisitions.store';
import { JobsWrapperActionsService } from './jobs/jobs-wrapper/jobs-wrapper-actions.service';

@Injectable({ providedIn: 'root' })
export class OffersGlobalEffects {
  private readonly jobsWrapperActionsService = inject(JobsWrapperActionsService);
  private readonly actions$ = inject(Actions);

  private asyncJobActiveCollectionUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AsyncJobActions.finish),
      filter(
        ({ payload }) =>
          AsyncJobType.BulkOffersFollow === payload.job.type ||
          AsyncJobType.BulkOffersUnfollow === payload.job.type,
      ),
      map(() => this.jobsWrapperActionsService.fetchActiveCollectionActions()),
    ),
  );

  private asyncJobRetrieveBulkOffers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AsyncJobActions.finish),
      filter(({ payload }) => AsyncJobType.BulkOffersRetrieveArchived === payload.job.type),
      map(() => CurrentUserEntityActions.fetch()),
    ),
  );

  private asyncJobArchived$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AsyncJobActions.finish),
      filter(
        ({ payload }) =>
          AsyncJobType.BulkOffersDeleteArchived === payload.job.type ||
          AsyncJobType.BulkOffersRetrieveArchived === payload.job.type,
      ),
      map(() => this.jobsWrapperActionsService.fetchArchivedCollectionActions()),
    ),
  );

  private dataCopiedFromRequisitionToJob$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobRequisitionsActions.copyDataSuccess),
      map(({ payload }) =>
        JobRequisitionsActions.fetchOne({ payload: { offerId: payload.data.offer.id } }),
      ),
    ),
  );
}
